import { ILocationData } from 'meta/pages/v4/location'

type LocationsState = {
  locations: Record<string, ILocationData>
}

export type LocationState = {
  data: LocationsState
}

export const initialState: LocationState = {
  data: {
    locations: {},
  },
}
